import { useState } from 'react';
import { Icon, type IconName } from '@/components/brand/Icon';
import { cn } from '@/lib/cn';

const RATIOS = {
  portrait: 'aspect-[320/380]',
  landscape: 'aspect-[420/236]',
  square: 'aspect-square',
  hero: 'aspect-[560/620]',
  wide: 'aspect-[1248/440]',
  tile: 'aspect-[400/260]',
  subject: 'aspect-[520/460]',
  strip: 'aspect-[416/145]',
} as const;

export function MediaFrame({
  src,
  alt,
  ratio = 'portrait',
  icon = 'image',
  className,
  imgClassName,
}: {
  src?: string | null | undefined;
  alt?: string | undefined;
  ratio?: keyof typeof RATIOS | undefined;
  icon?: IconName | undefined;
  className?: string | undefined;
  imgClassName?: string | undefined;
}): React.JSX.Element {
  const [failed, setFailed] = useState(false);

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={alt ?? ''}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
        className={cn('w-full object-cover', RATIOS[ratio], className, imgClassName)}
      />
    );
  }

  return (
    <div
      aria-hidden="true"
      className={cn(
        'flex w-full items-center justify-center bg-linear-[118deg,#1e1d38_14%,#080714_83%]',
        RATIOS[ratio],
        className,
      )}
    >
      <Icon name={icon} size={32} className="text-on-midnight/30" />
    </div>
  );
}
